import { render, staticRenderFns } from "./OfflineDeposit.vue?vue&type=template&id=5a5e828a&scoped=true&"
import script from "./OfflineDeposit.vue?vue&type=script&lang=js&"
export * from "./OfflineDeposit.vue?vue&type=script&lang=js&"
import style0 from "./OfflineDeposit.vue?vue&type=style&index=0&id=5a5e828a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5e828a",
  null
  
)

export default component.exports